module.exports = __webpack_public_path__ + "img/3ccb960.jpg";